import { List } from 'semantic-ui-react';

export default List;
